import { Box } from '@mui/system';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

const columns: GridColDef[] = [
  {
    field: 'col1',
    headerName: 'SR No',
    width: 120,
    resizable: true,
    disableColumnMenu: true,
  },
  { field: 'col2', headerName: 'App Login date', width: 150, disableColumnMenu: true },
  { field: 'col3', headerName: 'Customer Name', width: 150, disableColumnMenu: true },
  { field: 'col4', headerName: 'CIF', width: 100, disableColumnMenu: true },
  { field: 'col6', headerName: 'Request Type', width: 120, disableColumnMenu: true },
  { field: 'col7', headerName: 'Facility Type', width: 120, disableColumnMenu: true },
  { field: 'col8', headerName: 'Facility', width: 120, disableColumnMenu: true },
  { field: 'col9', headerName: 'Facility Currency', width: 120, disableColumnMenu: true },
  { field: 'col10', headerName: 'Facility Amount', width: 120, disableColumnMenu: true },
  { field: 'col11', headerName: 'List Of Items', width: 120, disableColumnMenu: true },
];

const PendingDisbursment = () => {
  return (
    <Box sx={{ padding: 2, height: '580px' }}>
      <DataGrid columns={columns} rows={[]} />
    </Box>
  );
};

export default PendingDisbursment;
